import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setReportSuccess, setShowReport } from "../../redux/actions/actions";
import { BIGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";

export const ReportSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reportSuccess, reportData, multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_YOUR_FEEDBACK_HAS_BEEN_SUBMITTED = English?.ReportModal
      ?.TEXT_YOUR_FEEDBACK_HAS_BEEN_SUBMITTED,
    TEXT_OK = English?.ReportModal?.TEXT_OK
  } = multiLanguageData?.ReportModal || {};

  const refreshData = () => {
    if (reportData.recordId === Number(id)) {
      dispatch(setReportSuccess(false));
      let reportObj = {
        showReport: false,
        recordId: 0,
        name: "",
        AppScreenId: 0
      };
      dispatch(setShowReport(reportObj));
      navigate(-1);
    } else {
      dispatch(setReportSuccess(false));
    }
  };

  return (
    <Modal
      open={reportSuccess ?? false}
      onClose={() => refreshData()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          padding: {
            xs: "10px ",
            xl: " 15px",
            lg: " 15px",
            md: " 15px",
            sm: " 15px"
          }
        }}
        className="client-modal-responsive">
        <Stack
          mb={1}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          flexDirection={"row"}>
          <IconButton
            size="small"
            sx={{ cursor: "pointer" }}
            color={BIGrey}
            onClick={() => refreshData()}>
            <Close />
          </IconButton>
        </Stack>
        <Stack mb={1}>
          <Typography variant="h6">{TEXT_YOUR_FEEDBACK_HAS_BEEN_SUBMITTED}</Typography>
        </Stack>
        <Stack
          mb={1}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          flexDirection={"row"}>
          <Button variant="contained" color="primary" onClick={() => refreshData()}>
            {TEXT_OK}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
